<div class="pie-chart-item">
  <svg 
    class="pie-chart-svg" 
    viewBox="0 0 100 100"
    role="img"
    [attr.aria-label]="getAriaLabel()"
    [attr.width]="size"
    [attr.height]="size">
    <title>{{ label }} - {{ validatedPercentage }}%</title>
    <!-- Background circle -->
    <circle cx="50" cy="50" r="50" fill="#E8E8E8" />
    <!-- Pie segment -->
    <circle 
      cx="50" 
      cy="50" 
      r="50" 
      fill="none" 
      [attr.stroke]="color" 
      stroke-width="100" 
      [attr.stroke-dasharray]="getPieDasharray(validatedPercentage)" 
      transform="rotate(-90 50 50)" />
  </svg>
  <div class="pie-chart-info">
    <div class="pie-chart-percentage-text" aria-hidden="true">{{ validatedPercentage }}%</div>
    <div class="pie-chart-label" aria-hidden="true">{{ label }}</div>
  </div>
</div>
